import React, { useState } from "react";
import { useAppContext } from "../../helpers/account-context";
import { toPermalink, ICONS } from "../../helpers/helper";
import { DetailLine, ResultLine, InfowinLine } from "./Mixin";

const weekdays = [
  { label: "monday", value: "mon", wday: 1 },
  { label: "tuesday", value: "tue", wday: 2 },
  { label: "wednesday", value: "wed", wday: 3 },
  { label: "thursday", value: "thu", wday: 4 },
  { label: "friday", value: "fri", wday: 5 },
  { label: "saturday", value: "sat", wday: 6 },
  { label: "sunday", value: "sun", wday: 0 },
];


const OpeningHours = (props) => {
  const { item, isToggle = true, defaultShown = false } = props;
  const [shown, setShown] = useState(defaultShown);
  const wday = new Date().getDay();
  const today = weekdays.find((d) => d.wday === wday);
  const { getLocale } = useAppContext();
  const toggleHours = (e) => {
    e.preventDefault();
    if(isToggle) {
      setShown(!shown)
    }
  }
  return (
      <div className={`cbmap-opening-time ${shown ? "is-shown" : ""}`}>
      <div className={`cbmap-opening-today cbmap-opening-today_${toPermalink(item.properties[today.value])}`}>
        <span className="cbmap-opening-today-label">{getLocale('today')}:</span>{" "}
        <span className={`cbmap-opening-today-time`} onClick={toggleHours}>
          {item.properties[today.value] || "-"}
        </span>
        {
          isToggle && <span
          className="cbmap-caret"
          dangerouslySetInnerHTML={{ __html: ICONS.CARET }}
          onClick={toggleHours}
          title={shown ? getLocale('hide') : getLocale('show')}
        />
        }
        
      </div>
      <div className={`cbmap-opening-week`}>
        {weekdays.map((day) => (
          <div
            className={`cbmap-opening-wday cbmap-opening-wday_${toPermalink(
              day.value
            )} ${today.value === day.value ? "is-today" : ""}
            cbmap-opening-wday_${toPermalink(item.properties[day.value])}
          `}
            key={day.value}
          >
            <div className="cbmap-opening-day-label">{getLocale(day.label)}:</div>
            <div className="cbmap-opening-day-time">
              {item.properties[day.value] || "-"}
            </div>
          </div>
        ))}
      </div>
    </div>
  

  );
};

export const HoursResult = (props) => {
  const {
    item,
  } = props;

  const wday = new Date().getDay();

  const today = weekdays.find((d) => d.wday === wday);
  if (!item.properties[today.value]) return null;

  return (
      <ResultLine className="cbmap-item_hours">
        <OpeningHours item={item} isToggle={false} />
      </ResultLine>
  );
};


export const HoursDetail = (props) => {
  const {
    item,
  } = props;
  if(!weekdays.find((d) => (!!item.properties[d.value]))) return null;

  return (
    <DetailLine className="cbmap-details_hours">
      <OpeningHours item={item} defaultShown={true}/>
    </DetailLine>
  );
};
export const HoursInfowin = (props) => {
  const {
    item,
  } = props;
  if(!weekdays.find((d) => (!!item.properties[d.value]))) return null;

  return (
    <InfowinLine className="cbmap-infowin_hours">
      <OpeningHours item={item} />
    </InfowinLine>
  
  );
};
